import { DirectoryPermissionApi } from './permission-api-client/api/directory-permission-api';
import { initializePermissionApi } from './utils';

// Dedicated API client for Directory Permissions (Permission API)
export const directoryPermissionApi = initializePermissionApi(DirectoryPermissionApi);
